import { useEffect } from 'react';

/**
 * Hook to listen for Shift+Enter key combination on document level
 * @param callback - Function to call when Shift+Enter is pressed
 * @param enabled - Whether the listener is enabled (default: true)
 */
export const useShiftEnter = (callback: () => void, enabled: boolean = true) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && event.shiftKey) {
        // Prevent default behavior
        event.preventDefault();
        // Call the callback
        callback();
      }
    };

    if (enabled) {
      // Add event listener to document
      document.addEventListener('keydown', handleKeyDown);
    }
    // Cleanup: remove event listener on unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, enabled]);
};
